import { render, staticRenderFns } from "./ResourceContent.vue?vue&type=template&id=01dddfbc"
import script from "./ResourceContent.vue?vue&type=script&lang=js"
export * from "./ResourceContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports